import { tokens, components } from '@quotient/riq-react-ui/theme';

components.InputAddon = {
  padding: 0,
  border: 'none',
  Button: {
    ':hover:not(:disabled)': {
      backgroundColor: 'primary',
      color: 'white'
    }
  }
};

export { tokens, components };
